(() => {
  'use strict';
  const en = document.documentElement.lang.startsWith('en');
  const text = (es, english) => en ? english : es;
  const isMobile = () => matchMedia('(pointer:coarse)').matches && matchMedia('(max-width:1366px)').matches;
  const standalone = () => matchMedia('(display-mode:standalone)').matches || navigator.standalone === true;
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, String(value)); } catch {} };
  let installEvent;
  const panel = document.createElement('aside');
  panel.className = 'dps-install-notice';
  panel.hidden = true;
  panel.setAttribute('aria-label', text('DJ Pool Store en tu celular', 'DJ Pool Store on your phone'));
  const title = document.createElement('strong');
  title.textContent = text('Tu música, más a mano.', 'Your music, one tap away.');
  const copy = document.createElement('p');
  copy.textContent = text('Añade DJ Pool Store a tu pantalla de inicio.', 'Add DJ Pool Store to your home screen.');
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'dps-install-action';
  button.textContent = text('Añadir', 'Add');
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'dps-install-dismiss';
  close.setAttribute('aria-label', text('Ahora no', 'Not now'));
  close.textContent = '×';
  const dismiss = () => { panel.hidden = true; write('dps-install-dismissed', Date.now()); };
  close.addEventListener('click', dismiss);
  panel.append(close, title, copy, button);
  document.body.append(panel);

  function showInstructions() {
    let dialog = document.getElementById('dps-install-instructions');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'dps-install-instructions';
      dialog.className = 'dps-install-instructions';
      const heading = document.createElement('h2');
      heading.textContent = text('DJ Pool Store en tu pantalla de inicio', 'DJ Pool Store on your home screen');
      const steps = document.createElement('p');
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      steps.textContent = ios
        ? text('Abre esta página en Safari. Toca Compartir y después Añadir a pantalla de inicio. Confirma con Añadir.', 'Open this page in Safari. Tap Share, then Add to Home Screen. Confirm with Add.')
        : text('Abre el menú de tu navegador (⋮ o ☰) y elige Instalar aplicación o Añadir a pantalla de inicio. Si estás dentro de otra app, abre primero la página en Chrome o Samsung Internet.', 'Open your browser menu (⋮ or ☰), then choose Install app or Add to Home screen. If you are inside another app, open the page in Chrome or Samsung Internet first.');
      const note = document.createElement('p');
      note.textContent = text('Necesitas conexión para escuchar música, abrir paquetes y comprar.', 'An internet connection is needed to listen, browse packs and shop.');
      const done = document.createElement('button');
      done.type = 'button';
      done.textContent = text('Entendido', 'Got it');
      done.addEventListener('click', () => dialog.close());
      dialog.append(heading, steps, note, done);
      document.body.append(dialog);
    }
    dialog.showModal();
  }

  async function install() {
    panel.hidden = true;
    if (!installEvent) { write('dps-install-dismissed', Date.now()); showInstructions(); return; }
    const event = installEvent;
    installEvent = null;
    await event.prompt();
    const choice = await event.userChoice;
    if (choice.outcome === 'accepted') { write('dps-install-previously-installed', '1'); write('dps-install-dismissed', Date.now()); }
    else dismiss();
  }
  button.addEventListener('click', install);
  const footerButton = document.createElement('button');
  footerButton.type = 'button';
  footerButton.className = 'dps-install-footer';
  footerButton.textContent = text('Añadir a pantalla de inicio ↗', 'Add to home screen ↗');
  footerButton.addEventListener('click', install);
  document.querySelector('.footer-legal')?.append(footerButton);

  window.addEventListener('beforeinstallprompt', event => {
    if (!isMobile() || standalone()) return;
    event.preventDefault();
    installEvent = event;
    button.textContent = read('dps-install-previously-installed') === '1'
      ? text('Instalar de nuevo', 'Install again') : text('Instalar', 'Install');
  });
  window.addEventListener('appinstalled', () => {
    write('dps-install-dismissed', Date.now());
    panel.hidden = true;
    footerButton.hidden = true;
    installEvent = null;
    write('dps-install-previously-installed', '1');
  });
  setTimeout(() => {
    const dismissed = Number(read('dps-install-dismissed') || 0);
    let shownThisSession = false;
    try { shownThisSession = sessionStorage.getItem('dps-install-shown') === '1'; } catch {}
    if (!isMobile() || standalone() || shownThisSession || Date.now() - dismissed < 7 * 86400000) return;
    if (document.querySelector('dialog[open]')) return;
    panel.hidden = false;
    try { sessionStorage.setItem('dps-install-shown', '1'); } catch {}
  }, 25000);
  const offline = document.createElement('div');
  offline.className = 'dps-offline-notice';
  offline.setAttribute('role', 'status');
  offline.textContent = text('Sin conexión. Vuelve a conectarte para escuchar y comprar.', 'You are offline. Reconnect to listen and shop.');
  document.body.append(offline);
  const connectivity = () => { offline.hidden = navigator.onLine; };
  window.addEventListener('online', connectivity);
  window.addEventListener('offline', connectivity);
  connectivity();
  footerButton.hidden = standalone() || !isMobile();
})();
